import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25bcd1c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "tap1"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "报修确认", -1));
const _hoisted_4 = {
  class: "activity"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店", -1));
const _hoisted_6 = {
  class: "cl7c7c7c"
};
const _hoisted_7 = {
  class: "activity vendor"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点位", -1));
const _hoisted_9 = {
  class: "cl7c7c7c"
};
const _hoisted_10 = {
  class: "imgBox"
};
const _hoisted_11 = {
  class: "activity location vendor"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态", -1));
const _hoisted_13 = {
  class: "imgUp"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "维修照片", -1));
const _hoisted_15 = {
  class: "storeBox defect"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "缺陷内容描述", -1));
const _hoisted_17 = {
  class: "text"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "btnBox"
};
const _hoisted_20 = {
  class: "tab2"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "验收确认", -1));
const _hoisted_22 = {
  class: "activity"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店", -1));
const _hoisted_24 = {
  class: "cl7c7c7c"
};
const _hoisted_25 = {
  class: "imgUp"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "验收单照片", -1));
const _hoisted_27 = {
  class: "rowBox"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验收人", -1));
const _hoisted_29 = {
  class: "rowBox"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系方式", -1));
const _hoisted_31 = {
  class: "rowBox btm"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备注", -1));
const _hoisted_33 = {
  class: "rowBox btm btm2"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin": "5px 0"
  }
}, "验收人签字", -1));
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "btnBox"
};
const _hoisted_40 = {
  key: 0,
  class: "drawBox"
};
const _hoisted_41 = {
  class: "btnBox"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "完成", -1));
const _hoisted_43 = [_hoisted_42];
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "重置", -1));
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回", -1));
const _hoisted_47 = [_hoisted_46];
const _hoisted_48 = {
  class: "canvasBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  const _component_EditPen = _resolveComponent("EditPen");
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($setup.uploadTableData.storeInfo.storeName), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString($setup.uploadTableData.storeInfo.storeFloor + "-" + $setup.uploadTableData.storeInfo.locationDescription), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString($setup.uploadTableData.storeInfo.repairResultNameZh), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
    "file-list": $setup.uploadTableData.uploadedList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => $setup.uploadTableData.uploadedList = $event),
    "list-type": "picture-card",
    ref: "uploadTable",
    action: $setup.uploadTableData.signatureData.host,
    data: $setup.uploadTableData.data,
    "on-preview": $setup.handlePictureCardPreview,
    disabled: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "action", "data", "on-preview"])])]), _withDirectives(_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_switch, {
    modelValue: $setup.uploadTableData.urgentFlag,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.uploadTableData.urgentFlag = $event),
    size: "large",
    onChange: _cache[2] || (_cache[2] = $event => $setup.switchChang($setup.uploadTableData.urgentFlag))
  }, null, 8, ["modelValue"])], 512), [[_vShow, $setup.uploadTableData.storeInfo.repairResultId !== 4]]), _withDirectives(_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_input, {
    style: {
      "width": "100%"
    },
    modelValue: $setup.uploadTableData.urgentText,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.uploadTableData.urgentText = $event),
    rows: 5,
    type: "textarea",
    placeholder: "请输入"
  }, null, 8, ["modelValue"])], 512), [[_vShow, $setup.uploadTableData.urgentFlag]])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.dialogVisible = $event),
    class: "preViewBox",
    style: {
      "width": "90vw",
      "height": "auto",
      "margin-top": "20vh"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "Preview Image",
      style: {
        "width": "100%"
      }
    }, null, 8, _hoisted_18)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: $setup.goTab2
  }, {
    default: _withCtx(() => [_createTextVNode("下一步")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    class: "defaultBtn",
    onClick: $setup.goBack
  }, {
    default: _withCtx(() => [_createTextVNode("返回")]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $setup.tab === 1]]), _withDirectives(_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", _hoisted_24, _toDisplayString($setup.uploadTableData.storeInfo.storeName), 1)]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
    class: "result-upload",
    "file-list": $setup.uploadResultPhotoData.fileList,
    "onUpdate:fileList": _cache[5] || (_cache[5] = $event => $setup.uploadResultPhotoData.fileList = $event),
    "list-type": "picture-card",
    limit: $setup.maxNum,
    ref: "uploadResultPhoto",
    "on-success": $setup.handleStoreOnSuccess,
    action: $setup.uploadResultPhotoData.signatureData.host,
    "before-upload": $setup.handleBefore,
    data: $setup.uploadResultPhotoData.data,
    "on-exceed": $setup.handleExceed,
    accept: "image/*"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "limit", "on-success", "action", "before-upload", "data", "on-exceed"])])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createVNode(_component_el_input, {
    style: {
      "width": "60%"
    },
    modelValue: $setup.ysNameInput,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.ysNameInput = $event),
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_input, {
    style: {
      "width": "60%"
    },
    modelValue: $setup.ysPhoneInput,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.ysPhoneInput = $event),
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_el_input, {
    style: {
      "width": "60%"
    },
    modelValue: $setup.remarkInput,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.remarkInput = $event),
    rows: 3,
    type: "textarea",
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, !$setup.drawBase64 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", {
    onClick: _cache[9] || (_cache[9] = $event => $setup.drawBoxShow = true)
  }, [_createVNode(_component_el_icon, {
    size: 30
  }, {
    default: _withCtx(() => [_createVNode(_component_EditPen)]),
    _: 1
  })])])) : (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", null, [_createElementVNode("div", {
    onClick: _cache[10] || (_cache[10] = $event => $setup.drawBoxShow = true),
    style: {
      "text-align": "center"
    }
  }, [_createVNode(_component_el_icon, {
    size: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_EditPen)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_37, [_createElementVNode("img", {
    src: $setup.drawBase64,
    alt: "",
    style: {
      "width": "60%"
    }
  }, null, 8, _hoisted_38)])])]))]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: $setup.submitAcceptResult
  }, {
    default: _withCtx(() => [_createTextVNode("完成")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    class: "defaultBtn",
    onClick: $setup.goTab1
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $setup.tab === 2]]), $setup.drawBoxShow ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", {
    onClick: _cache[11] || (_cache[11] = (...args) => $setup.save && $setup.save(...args))
  }, _hoisted_43), _createElementVNode("div", {
    onClick: _cache[12] || (_cache[12] = (...args) => $setup.undo && $setup.undo(...args))
  }, _hoisted_45), _createElementVNode("div", {
    onClick: _cache[13] || (_cache[13] = $event => $setup.drawBoxShow = false)
  }, _hoisted_47)]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_VueSignaturePad, {
    ref: "signaturePad"
  }, null, 512)])])) : _createCommentVNode("", true)]);
}